const getLocalStorageObject = key => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return null;
  }
};
export default getLocalStorageObject;
